// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__13Atb","validationTips":"StatementDescriptor_validationTips__5tDbu"};